import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import primaryContactImageSvg from 'images/user-check.svg';
import SimpleTable from 'components/shared/table/SimpleTable';
import { getRange } from 'services/utils/date-util';
import closePng from 'images/close.png';
import './ContactsModal.css';
import { formatPhoneNumber } from 'services/utils/text-util';

function handleClose(event, props) {
  event.preventDefault();
  props.onClose();
}

function mapContacts(users) {
  return users.map((user) => {
    return [
      user.primaryContact ? (
        <img src={primaryContactImageSvg} alt="primary-contact" />
      ) : null,
      <span className="small-bold">{user.name}</span>,
      user.title !== null ? user.title : 'N/A',
      user.email !== null ? user.email : 'N/A',
      user.phoneNumber !== null ? formatPhoneNumber(user.phoneNumber) : 'N/A',
      formatLastLogin(user.lastSignIn),
    ];
  });
}

export function formatLastLogin(lastLogin, today = null) {
  let result = 'N/A';
  if (lastLogin !== null) {
    const elapsedTime = getRange(lastLogin, today);
    if (elapsedTime.years > 0) {
      result = `${elapsedTime.years} ${
        elapsedTime.years > 1 ? 'years' : 'year'
      } ago`;
    } else if (elapsedTime.months > 0) {
      result = `${elapsedTime.months} ${
        elapsedTime.months > 1 ? 'months' : 'month'
      } ago`;
    } else if (elapsedTime.days > 0) {
      result = `${elapsedTime.days} ${
        elapsedTime.days > 1 ? 'days' : 'day'
      } ago`;
    } else if (elapsedTime.hours > 0) {
      result = `${elapsedTime.hours} ${
        elapsedTime.hours > 1 ? 'hours' : 'hour'
      } ago`;
    } else if (elapsedTime.minutes > 0) {
      result = `${elapsedTime.minutes} ${
        elapsedTime.minutes > 1 ? 'minutes' : 'minute'
      } ago`;
    } else {
      result = '0 minutes ago';
    }
  }
  return result;
}

export default function ContactsModal(props) {
  const headers = ['', 'NAME', 'TITLE', 'EMAIL', 'PHONE', 'LAST SIGN IN'];
  return (
    <Modal className="contacts-modal" show={props.show}>
      <Modal.Body>
        <div className="cm-container">
          <div className="h1">Contacts</div>
          <img
            src={closePng}
            alt="close"
            onClick={(event) => handleClose(event, props)}
          />
          <SimpleTable
            className="cm-contacts-table"
            headers={headers}
            rows={mapContacts(props.users)}
            emptyMessage="No Contacts"
          />
        </div>
      </Modal.Body>
      {props.footer !== null && <Modal.Footer>{props.footer}</Modal.Footer>}
    </Modal>
  );
}

ContactsModal.propTypes = {
  footer: PropTypes.node,
  show: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
      lastSignIn: PropTypes.string,
      name: PropTypes.string.isRequired,
      phoneNumber: PropTypes.string,
      primaryContact: PropTypes.bool,
      title: PropTypes.string,
    })
  ),
  onClose: PropTypes.func.isRequired,
};

ContactsModal.defaultProps = {
  footer: null,
  users: [],
};



// WEBPACK FOOTER //
// ./src/components/shared/modal/ContactsModal.js